:host .category-filter--hidden {
  position: absolute;
  z-index: 1;
  display: flex;
  justify-content: end;
  align-items: center;
  border-radius: 12px;
  right: 10px;
  margin-top: 12px;
  background-color: white;
}

:host .category-filter--hidden.mobile {
  margin-top: 16px;
}

:host([show-filters]) .category-filter {
  position: absolute;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  width: 100%;
  padding-top: 10px;
  align-items: center;

  &--hidden {
    position: absolute;
    z-index: 1;
    display: flex;
    justify-content: end;
    align-items: center;
    border-radius: 12px;
    right: 10px;
    margin-top: 12px;
    background-color: white;
  }

  &__hide-button {
    display: block;
    border-radius: 12px;
    background-color: white;
    height: 48px;
    width: 48px;
    margin-right: 10px;
  }

  &__list {
    margin: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 16px;
    width: 100%;

    &__item {
      list-style: none;

      &-button {
        cursor: pointer;
        background-color: transparent;
        display: flex;
        align-items: center;
        gap: 10px;
        border: 2px solid;
        border-radius: 12px;
        padding: 4px;
        width: 180px;
        font-family: 'Helvetica Now Text', sans-serif;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        background-color: white;

        &.stationery {
          border-color: #9ccf90;

          &.selected {
            background-color: #e6f3e5;
          }
        }

        &.clothing {
          border-color: #f9b98e;

          &.selected {
            background-color: #fdeee4;
          }
        }

        &.household {
          border-color: #6ec8f2;

          &.selected {
            background-color: #dcf1fd;
          }
        }
      }

      &-icon {
        height: 40px;
      }
    }
  }
}

:host([show-filters]) .category-filter.mobile {
  position: absolute;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr auto;
  width: 100%;
}

:host([show-filters]) .category-filter__list.mobile {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 0;
  padding-left: 29px;
}

:host([show-filters]) .category-filter__list__item-label.mobile {
  display: none;
}

:host([show-filters]) .category-filter__list__item-button.mobile {
  display: flex;
  width: auto;
  gap: 2px;
  padding: 8px;
}

@media screen and (max-width: 768px) {
  :host([show-filters]) .category-filter {
    position: absolute;
    z-index: 1;
    display: grid;
    grid-template-columns: 1fr auto;
    width: 100%;

    &--hidden {
      margin-top: 16px;
    }

    &__list {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 20px;
      padding: 0;

      &__item-label {
        display: none;
      }

      &__item-button {
        display: flex;
        width: auto;
        gap: 2px;
        padding: 8px;
      }
    }
  }
}
